@if (editable && !preview && form.controls[name]) {
  <div
    [formGroup]="form"
    data-type="select"
    class="form-input-{{name}} v2-input-select"
    >
    <mat-form-field class="full-width" [floatLabel]="floatLabel">
      <mat-label>{{ label }}</mat-label>
      <mat-select [formControlName]="name" [required]="required" [tabindex]="tabindex" disableOptionCentering panelClass="v2-mat-select">
        <mat-select-trigger>
          {{selectedValue}}
          @if (showNote) {
            <span class="option-note">{{optionNoteDict[selected]}}</span>
          }
        </mat-select-trigger>
        @for (option of optionList; track option) {
          <mat-option (click)="selectKey(option.key)" [value]="option.key">
            <span class="option-main">{{option.val}}</span>
            @if (showNote) {
              <span class="option-note">{{optionNoteDict[option.key]}}</span>
            }
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (errors[name]) {
      <mat-error class="select-error-container">
        <span style="font-size: 75%">{{ errors[name] }}</span>
      </mat-error>
    }
  </div>
}
